module.exports = __webpack_public_path__ + "img/L_502_0.cb611965.png";